/* eslint-disable no-continue */
/* eslint-disable no-param-reassign */
import moment from 'moment';
import BaseDataTransformer from '../base-data-transformer/base-data-transformer';

class GenericDataTransformer extends BaseDataTransformer {
  transform(data, options) {
    if (!options || data.data.length < 1) {
      return [];
    }

    if (options.mapKeyFigures) {
      options = options.mapKeyFigures;

      if (!options.dataPath || !options.columnMappings || options.columnMappings.length === 0) {
        throw Error('Invalid highchart series mapping configuration');
      }

      if (!data[options.dataPath]) {
        throw Error(`Could not find property '${options.dataPath}' in data`);
      }

      data = data[options.dataPath];

      const result = [];

      for (let i = 0; i < options.columnMappings.length; i++) {
        const { columnName } = options.columnMappings[i];
        const valuePath = options.columnMappings[i].valuesPath;
        const scaleFactor = options.columnMappings[i].scale || 1;

        result.push({
          name: columnName,
          value: scaleFactor * data[0][valuePath],
        });
      }

      return result;
    }

    if (options.mapHighchartsSeries) {
      options = options.mapHighchartsSeries;

      if (!options.dataPath || !options.columnMappings || options.columnMappings.length === 0) {
        throw Error('Invalid highchart series mapping configuration');
      }

      if (!data[options.dataPath]) {
        throw Error(`Could not find property '${options.dataPath}' in data`);
      }

      data = data[options.dataPath];
      const xAxisDefinition = options.xAxis;
      const result = [];


      for (let i = 0; i < options.columnMappings.length; i++) {
        const { columnName } = options.columnMappings[i];
        const valuePath = options.columnMappings[i].valuesPath;
        const scaleFactor = options.columnMappings[i].scale || 1;

        const values = [];
        for (let j = 0; j < data.length; j++) {
          if (!data[j][valuePath]) {
            continue;
          }

          let x = xAxisDefinition.format
            ? moment(data[j][xAxisDefinition.categoryPath]).toDate().getTime()
            : data[j][xAxisDefinition.categoryPath];

          if (xAxisDefinition.substring) {
            x = x.substring(0, xAxisDefinition.substring);
          }

          values.push([
            x,
            scaleFactor * data[j][valuePath],
          ]);
        }

        result.push({
          name: columnName,
          data: values,
        });
      }

      return result;
    }
    // var result = [];
    // $.each(data.columns,(i, column) => {
    //    var series = {
    //        name: column,
    //        data: $.map(data.data,ob => {
    //            return parseFloat(ob.values[i]);
    //        })
    //    };
    //    result.push(series);
    // });


    return null;
  }
}

export default GenericDataTransformer;
